import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "pixyquiz_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem(STORAGE_KEY, "refused");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[200] border-t border-emerald-100 bg-white/95 shadow-[0_-8px_32px_rgba(24,48,74,0.10)] backdrop-blur-xl">
      <div className="mx-auto flex max-w-screen-2xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 text-2xl" aria-hidden="true">🍪</span>
          <div>
            <p className="text-sm font-semibold text-pixy-ink">
              Ce site utilise des cookies
            </p>
            <p className="mt-1 text-xs leading-5 text-slate-500">
              Nous utilisons des cookies techniques necessaires au fonctionnement du site et des cookies de performance pour ameliorer votre experience.{" "}
              <Link
                to="/cookies"
                className="font-semibold text-pixy-blue underline-offset-2 hover:underline"
              >
                En savoir plus
              </Link>
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2 self-end sm:self-auto">
          <button
            type="button"
            onClick={refuse}
            className="rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-semibold text-slate-600 transition hover:border-slate-300 hover:bg-slate-50"
          >
            Refuser
          </button>
          <button
            type="button"
            onClick={accept}
            className="rounded-full bg-gradient-to-r from-pixy-green to-pixy-blue px-5 py-2 text-xs font-bold uppercase tracking-[0.18em] text-white shadow-md shadow-sky-300/30 transition hover:-translate-y-0.5 hover:shadow-sky-300/50"
          >
            Tout accepter
          </button>
        </div>
      </div>
    </div>
  );
}
